const MAPS = {
  uae: { img: "/mp/map-abudhabi.jpg", marker: { left: "55%", top: "47%" } },
  ca: { img: "/mp/map-california.jpg", marker: { left: "52%", top: "55%" } },
};

const RING_DELAYS = ["", "d2", "d3"];

// Location card using the stylized silhouette maps (dark land / light backdrop, no text) + MP marker.
export default function MPLocationMap({ city, region, variant = "uae" }) {
  const { img, marker } = MAPS[variant] || MAPS.uae;

  return (
    <div className="relative overflow-hidden h-[300px] md:h-[340px] bg-[#e8e3d7]" data-testid={`location-map-${variant}`}>
      <img src={img} alt={`${city} map`} className="absolute inset-0 w-full h-full object-cover" />

      {/* marker */}
      <div className="absolute -translate-x-1/2 -translate-y-1/2" style={marker}>
        <div className="relative">
          {RING_DELAYS.map((delay) => (
            <span
              key={delay || "d1"}
              className={`mp-ring absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-14 h-14 rounded-full border border-[#c9a15f] ${delay}`}
            />
          ))}
          <div className="relative w-11 h-11 rounded-full bg-[#c9a15f] flex items-center justify-center shadow-lg">
            <span className="font-display text-[#1c1a16] text-[16px] leading-none tracking-tight">MP</span>
          </div>
        </div>
      </div>

      {/* label */}
      <div className="absolute left-5 top-5">
        <div className="font-label text-[10px] text-[#6f665a]">{region}</div>
      </div>
    </div>
  );
}
